import request from '../utils/request';

export type ModuleApplicationStatus = 'pending' | 'approved' | 'rejected';

export interface ModuleAccessApplicationPayload {
  company_name?: string;
  website?: string;
  personal_name?: string;
  main_product_categories?: string[];
  sales_platform_links?: string[];
  phone_country_code?: string;
  phone_number?: string;
  social_accounts?: Record<string, string>;
  service_requirement_items?: string[];
  service_requirement_description?: string;
}

export interface ModuleAccessApplication {
  id: number;
  module_key: string;
  module_label: string;
  status: ModuleApplicationStatus;
  status_label: string;
  payload: ModuleAccessApplicationPayload;
  review_note?: string | null;
  created_at: string;
  updated_at: string;
}

export const getMyModuleAccessApplications = async (moduleKey?: string) => {
  const response = await request.get<ModuleAccessApplication[]>('/api/v1/users/module-access-applications/mine/', {
    params: moduleKey ? { module_key: moduleKey } : undefined,
  });
  return response.data || [];
};

export const submitModuleAccessApplication = async (
  moduleKey: string,
  payload: ModuleAccessApplicationPayload,
) => {
  const response = await request.post<ModuleAccessApplication>('/api/v1/users/module-access-applications/', {
    module_key: moduleKey,
    payload,
  });
  return response.data;
};

export const validateWebsiteUrl = async (website?: string) => {
  const response = await request.get<{ valid: boolean; normalized?: string | null; detail?: string }>(
    '/api/v1/users/website-validate/',
    { params: { website: website || '' } }
  );
  return response.data;
};

export const getAdminModuleAccessApplications = async (params?: { applicant_id?: string; status?: string }) => {
  const response = await request.get<ModuleAccessApplication[]>('/api/v1/users/module-access-applications/admin/list/', {
    params,
  });
  return response.data || [];
};

export const reviewModuleAccessApplication = async (
  applicationId: number,
  action: 'approve' | 'reject',
  reviewNote?: string,
) => {
  const response = await request.post<ModuleAccessApplication>(
    `/api/v1/users/module-access-applications/${applicationId}/review/`,
    { action, review_note: reviewNote || undefined },
  );
  return response.data;
};

